import type { Resource } from '../types/content'

// Copertine italiane definitive (IT_01 … IT_06). Usate anche per le miniature
// dell’offerta e come immagine di riserva del video hero.

export const mainGuide: Resource = {
  id: 'guida',
  kind: 'guide',
  name: 'L’Atelier delle Vetrate Creative',
  benefit: 'Imparare la tecnica dall’inizio',
  description:
    'Dalla preparazione del supporto alle rifiniture: tracciare contorni regolari, applicare il colore, rispettare i tempi di asciugatura dei tuoi prodotti ed evitare gli errori più frequenti.',
  // IT_01_manual_principal_v01.png
  image:
    'https://cdn.magicpatterns.com/uploads/uTrLnWKmVqg9m7vzGLJ1TT/IT_01_manual_principal_v01.png',
  imageAlt:
    'Copertina della guida L’Atelier delle Vetrate Creative, decorata con un colibrì multicolore',
}

export const bonuses: Resource[] = [
  {
    id: 'materiali',
    kind: 'bonus',
    number: 1,
    name: 'Scegliere bene i materiali',
    benefit: 'Attrezzarti senza esitazioni',
    description:
      'Per riconoscere colori, contorni e supporti compatibili tra loro, e preparare uno spazio di lavoro pratico prima della tua prima sessione.',
    // IT_02_guia_materiales_v01.png
    image:
      'https://cdn.magicpatterns.com/uploads/61Yhch5kWcp4GozjkVDhod/IT_02_guia_materiales_v01.png',
    referencePrice: 10,
    imageAlt:
      'Libro Scegliere bene i materiali appoggiato su un tessuto, con barattoli di colore e una piccola placca fiorita',
  },
  {
    id: 'modelli-ricalcare',
    kind: 'bonus',
    number: 2,
    name: 'I miei modelli da ricalcare',
    benefit: 'Acquistare sicurezza nel tratto',
    description:
      'Modelli semplici per esercitarti con linee, curve e contorni chiusi prima di passare al colore.',
    // IT_03_plantillas_iniciales_v01.png
    image:
      'https://cdn.magicpatterns.com/uploads/oiPUEchj7DiYNaZxD5mSXo/IT_03_plantillas_iniciales_v01.png',
    referencePrice: 10,
    imageAlt:
      'Libro I miei modelli da ricalcare circondato da fogli con motivi semplici e da un tablet che mostra disegni al tratto',
  },
  {
    id: 'prime-creazioni',
    kind: 'bonus',
    number: 3,
    name: 'Le mie prime creazioni',
    benefit: 'Mettere in pratica la tecnica passo dopo passo',
    description:
      'Sei progetti guidati, dal più semplice al più dettagliato, per applicare ciò che impari nella guida.',
    // IT_04_primeras_creaciones_v01.png
    image:
      'https://cdn.magicpatterns.com/uploads/n8zyuyuowfWqnXaBez5J7P/IT_04_primeras_creaciones_v01.png',
    referencePrice: 10,
    imageAlt:
      'Una donna in un laboratorio luminoso tiene una placca fiorita con effetto vetrata, accanto al libro Le mie prime creazioni',
  },
  {
    id: 'colori',
    kind: 'bonus',
    number: 4,
    name: 'Il mio quaderno dei colori',
    benefit: 'Creare armonie di colore',
    description:
      'Dodici palette per aiutarti a scegliere le tinte e a distribuirle in modo armonioso su un motivo.',
    // IT_05_cuaderno_colores_v01.png
    image:
      'https://cdn.magicpatterns.com/uploads/6xAaezPJCx2r2s2wjDPZWA/IT_05_cuaderno_colores_v01.png',
    referencePrice: 10,
    imageAlt:
      'Libro Il mio quaderno dei colori accanto a una fila di quadrati di vetro colorato',
  },
]

export const templateLibrary: Resource = {
  id: 'biblioteca',
  kind: 'bonus',
  number: 5,
  name: '100+ modelli per l’effetto vetrata',
  benefit: 'Scegliere la tua prossima creazione',
  description:
    'Una raccolta di oltre 100 modelli vari da ricalcare, per continuare a creare dopo i primi esercizi.',
  // IT_06_biblioteca_modelos_v01.png
  image:
    'https://cdn.magicpatterns.com/uploads/bB2ZMRF1tvfp8iRheVR1jR/IT_06_biblioteca_modelos_v01.png',
  /** Prezzo individuale reale confermato dalla proprietaria. */
  referencePrice: 10,
  imageAlt:
    'Libro 100+ modelli per effetto vetrata appoggiato su numerosi fogli di motivi dettagliati: fiori, pavone, colibrì, libellula, farfalla, sole e luna',
}

export const allResources: Resource[] = [mainGuide, ...bonuses, templateLibrary]
